import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getAmountWithSymbol } from 'components/event_type_edit';
import { PaymentAmount } from './payment_amount';
import { PaymentOptions } from './payment_options';
import { PaymentTerms } from './payment_terms';
import { StatusBanner } from './status_banner';
import { useDebouncedFormContext } from '../../hooks';
import { InlineEditingContainer } from '../styles';
const getPaymentDisplayText = (provider, amountWithSymbol) => {
  const providerMessages = {
    paypal: I18n.t('publisher.managed_event_types.payment.paypal', {
      amount: amountWithSymbol
    }),
    stripe: I18n.t('publisher.managed_event_types.payment.stripe', {
      amount: amountWithSymbol
    })
  };
  return providerMessages[provider] || amountWithSymbol;
};
const paymentWrapperCss = "p1ost768";
const PaymentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paymentWrapperCss, props.className)} />;
});
export const PaymentCollectionInputs = ({
  provider,
  paymentMethodEnabled,
  isUpgradeRequired,
  isStripeConnected,
  isPaypalConnected
}) => {
  const showPaymentAmount = provider !== 'none';
  return <PaymentWrapper>
      <StatusBanner provider={provider} isStripeConnected={isStripeConnected} isPaypalConnected={isPaypalConnected} />
      <PaymentOptions provider={provider} paymentMethodEnabled={paymentMethodEnabled} isPaymentsIntegrationAvailable={!isUpgradeRequired} isStripeConnected={isStripeConnected} isPaypalConnected={isPaypalConnected} />
      {showPaymentAmount && <InlineEditingContainer>
          <PaymentAmount />
          <PaymentTerms />
        </InlineEditingContainer>}
    </PaymentWrapper>;
};
export const LockedCollectPaymentSection = ({
  paymentMethodEnabled
}) => {
  const {
    values
  } = useDebouncedFormContext();
  if (!paymentMethodEnabled) {
    return <BodyText>{I18n.t('publisher.managed_event_types.payment.no_payment')}</BodyText>;
  }
  const {
    currency,
    provider,
    amount
  } = values;
  const amountWithSymbol = getAmountWithSymbol({
    currency,
    amount
  });
  return <BodyText>{getPaymentDisplayText(provider, amountWithSymbol)}</BodyText>;
};

require("./collect_payment.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./collect_payment.js");